import React from 'react';
import { useTranslation } from 'react-i18next';
import { MeetingInformation, NetworStatus } from '../../types';
import StatusCard from '../common/StatusCard/StatusCard';
import './InsuranceVerificationDetails.scss';

type props = {
  payerName: string;
  networkStatus: NetworStatus;
  className?: string;
  serviceCoveredInNetwork?: string;
  meetingInfo?: MeetingInformation;
};

export const InsuranceNetworkStatus: React.FC<props> = ({
  className,
  meetingInfo,
  serviceCoveredInNetwork,
  networkStatus,
  payerName: _payerName,
}: props) => {
  const { t } = useTranslation('insuranceVerification');

  // Assuming therapist_profile_pic_url and therapist_name exist on meetingInfo object
  const therapistPic = meetingInfo?.therapist_profile_pic_url;
  const therapistName = meetingInfo?.therapist_name;

  if (serviceCoveredInNetwork === 'YES') {
    if (networkStatus === 'IN_NETWORK') {
      return (
        <StatusCard
          containerClass="insurance-in-network-container"
          className={className}
          therapistPic={therapistPic}
          therapistName={therapistName}
          statusLabel={t('insuranceNetworkStatus.inNetworkLabel')}
          statusLabelColor="color-solid-green"
          description={t('insuranceNetworkStatus.inNetworkDescription')}
        />
      );
    } else if (networkStatus === 'OUT_OF_NETWORK') {
      return (
        <StatusCard
          containerClass="insurance-not-in-network-container"
          className={className}
          therapistPic={therapistPic}
          therapistName={therapistName}
          statusLabel={t('insuranceNetworkStatus.notInNetworkLabel')}
          statusLabelColor="color-solid-red"
          description={t('insuranceNetworkStatus.notInNetworkDescription')}
        />
      );
    } else if (networkStatus === 'INSURANCE_IN_NETWORK_REVIEW') {
      return (
        <StatusCard
          containerClass="insurance-in-review-container"
          className={className}
          therapistPic={therapistPic}
          therapistName={therapistName}
          statusLabel={t('insuranceNetworkStatus.inReviewLabel')}
          description={t('insuranceNetworkStatus.inReviewDescription')}
          networkStatus={networkStatus}
        />
      );
    }
  }else if (serviceCoveredInNetwork === 'NO' ) {
    return (
      <StatusCard
        containerClass="insurance-not-covered-container"
        className={className}
        therapistPic={therapistPic}
        therapistName={therapistName}
        statusLabel={t('insuranceNetworkStatus.mentalHealthNotCoveredLabel')}
        statusLabelColor="color-solid-red"
        description={t('insuranceNetworkStatus.mentalHealthNotCoveredDescription')}
      />
    );
  }
  
  return <></>;
};
